/**
 * Central color literal registry.
 * Keep raw colors in config only; reference APP_COLORS everywhere else.
 */
export const APP_COLORS = {
  hex_00758f: "#00758F",
  hex_00bfb3: "#00BFB3",
  hex_06aed5: "#06AED5",
  hex_06d6a0: "#06D6A0",
  hex_073b4c: "#073B4C",
  hex_0f80cc: "#0F80CC",
  hex_118ab2: "#118AB2",
  hex_1287b1: "#1287B1",
  hex_12b76a: "#12B76A",
  hex_13aa52: "#13AA52",
  hex_1a1a1a_2: "#1A1A1A",
  hex_1a1a2e: "#1a1a2e",
  hex_2d2d2d: "#2D2D2D",
  hex_336791: "#336791",
  hex_3b82f6: "#3B82F6",
  hex_48cae4: "#48CAE4",
  hex_4ade80: "#4ADE80",
  hex_4e9fdd: "#4e9fdd",
  hex_52876b: "#52876B",
  hex_5e35b1: "#5E35B1",
  hex_5e60ce: "#5E60CE",
  hex_5e9ed6: "#5E9ED6",
  hex_5eb8ff: "#5EB8FF",
  hex_666: "#666",
  hex_66c7e0: "#66C7E0",
  hex_6b7280_2: "#6B7280",
  hex_6db33f: "#6DB33F",
  hex_6edb8f: "#6EDB8F",
  hex_73bf69: "#73bf69",
  hex_73c991: "#73C991",
  hex_7c7ff2: "#7C7FF2",
  hex_7e8ea0: "#7e8ea0",
  hex_83d483: "#83D483",
  hex_8e8e8e: "#8e8e8e",
  hex_98a2b3: "#98A2B3",
  hex_98d660: "#98D660",
  hex_c00021: "#c00021",
  hex_c8d43d_2: "#C8D43D",
  hex_cc2927: "#CC2927",
  hex_dc2626: "#DC2626",
  hex_dc382d: "#DC382D",
  hex_e0b400: "#e0b400",
  hex_e0e0e0: "#e0e0e0",
  hex_eab308: "#EAB308",
  hex_e8494d: "#e8494d",
  hex_e86b69: "#E86B69",
  hex_ef4444: "#EF4444",
  hex_ef476f: "#EF476F",
  hex_f04438: "#F04438",
  hex_f29111: "#F29111",
  hex_f78c6b: "#F78C6B",
  hex_f79009: "#F79009",
  hex_f7b63a_2: "#F7B63A",
  hex_f80000: "#F80000",
  hex_fec514: "#FEC514",
  hex_ff4d5a_2: "#FF4D5A",
  hex_ff6b35: "#FF6B35",
  hex_ff6b6b: "#FF6B6B",
  hex_ffd166: "#FFD166",
  hex_fff: "#fff",
  rgba_18_183_106_0p12: "rgba(18,183,106,0.12)",
  rgba_18_183_106_0p3: "rgba(18,183,106,0.3)",
  rgba_240_68_56_0p12_2: "rgba(240,68,56,0.12)",
  rgba_240_68_56_0p3_2: "rgba(240,68,56,0.3)",
  rgba_240_68_56_0p5: "rgba(240, 68, 56, 0.5)",
  rgba_247_144_9_0p15: "rgba(247,144,9,0.15)",
  rgba_247_144_9_0p3_2: "rgba(247,144,9,0.3)",
  rgba_250_173_20_0p2: "rgba(250, 173, 20, 0.2)",
  rgba_255_255_255_0p03: "rgba(255, 255, 255, 0.03)",
  rgba_255_255_255_0p05: "rgba(255, 255, 255, 0.05)",
  rgba_255_255_255_0p06: "rgba(255, 255, 255, 0.06)",
  rgba_255_255_255_0p06_2: "rgba(255,255,255,0.06)",
  rgba_255_255_255_0p7: "rgba(255,255,255,0.7)",
  rgba_255_77_79_0p2: "rgba(255, 77, 79, 0.2)",
  rgba_94_96_206_0p2: "rgba(94, 96, 206, 0.2)",
} as const;
